import { CustomConfirmDialogComponent } from "./../../../shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { InventoryItemsForMiscComponent } from "src/app/shared/components/inventory-items-for-misc/inventory-items-for-misc.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-inventory",
  templateUrl: "./inventory.component.html",
  styleUrls: ["./inventory.component.scss"],
})
export class InventoryComponent implements OnInit, OnDestroy {
  inventoryStatus: any = {
    total_items_count: 0,
    low_stock_count: 0,
    out_of_stock_count: 0,
  };
  inventoryActivityData: any[] = [];
  tableDisplayColumn: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "inventory.column_headers.date"
      ),
      columnProperty: "creation_time",
    },
    {
      columnName: this.translateService.instant("inventory.column_headers.by"),
      columnProperty: "created_by",
    },
    {
      columnName: this.translateService.instant(
        "inventory.column_headers.name"
      ),
      columnProperty: "item_name",
    },
    {
      columnName: this.translateService.instant("inventory.column_headers.qty"),
      columnProperty: "p_quantity",
    },
    // {
    //   columnName: 'Activity',
    //   columnProperty: "p_quantity",
    // },
    // {
    //   columnName: this.translateService.instant(
    //     "inventory.column_headers.unit"
    //   ),
    //   columnProperty: "purchase_unit",
    // },
    // {
    //   columnName: this.translateService.instant(
    //     "inventory.column_headers.qty_info"
    //   ),
    //   columnProperty: "quantity_info",
    // },
    {
      columnName: "notes",
      columnProperty: "nts"
    },
    {
      columnName: "activity",
      columnProperty: "activity_type"
    }
  ];
  entityHashId: string = "";
  entityHashIdForSearch: string = "";
  datalength!: number;
  public page: number = 1;
  public loader: boolean = false;
  _apiSubscription: Subscription;
  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog,
    private _navService: NavigationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    private route: ActivatedRoute,
    private authService:AuthService,
    private _modelRef: MatDialog
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData) {
        if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_GET_ENTITY_INVENTORY_IN_OUT_DATA
        ) {
          this.inventoryActivityData = [];
          if (resData.result && resData.result != "null") {
            this.inventoryActivityData = resData.result;
            this.datalength = resData?.result[0].total_count ? resData?.result[0].total_count : 0 
            this.inventoryActivityData = resData.result.map((item: any) => {
              // Creating a new object with all the same keys and values
              const newItem = { ...item };

              // Adding a new custom key with a custom value
              newItem.activity_type = item.operation_type == 1 ? "In" : "Out";
              newItem.p_quantity = item.purchase_unit == item.selling_unit ? `${item.purchase_quantity} ${item.purchase_unit}` : `${item.purchase_quantity} ${item.purchase_unit} (${item.selling_quantity} ${item.selling_unit})`;
              newItem.nts = newItem.notes && newItem.notes != 'null' ? newItem.notes : '---' 
              return newItem;
            });
          }

          this._apiService.getEntityInventoryStatus(this.entityHashId);
          // this.loader = false;
          // this.loaderservice.showLoader = false
        }
        if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_GET_ENTITY_INVENTORY_STATUS
        ) {
          this.inventoryStatus = {
            total_items_count: 0,
            low_stock_count: 0,
            out_of_stock_count: 0,
          };
          if (resData.result) {
            this.inventoryStatus = resData.result;
          }
          this.loader = false;
          this.loaderservice.showLoader = false;
        }
        if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_EDIT_INVENTORY_ACTIVITY
        ) {
          if (resData.result && resData.result != "null") {
            // this.loader = true;
            this.loaderservice.showLoader = true;
            this._apiService.getEntityInventoryInOutData(
              this.entityHashId,
              this.page.toString()
            );
          }
        } else if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_SET_INVENTORY_ITEM_ACTIVITY
        ) {
          if (resData.result && resData.result != null) {
            this._apiService.getEntityInventoryInOutData(
              this.entityHashId,
              this.page.toString()
            );
          }
        }
        this.translateService.onLangChange.subscribe(() => {
          // Update your column headers when the language changes
          this.updateColumnHeaders();
        });
      }
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumn.forEach((column, index) => {
      let data = ["date", "by", "name", "qty", "unit", "qty_info"];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `inventory.column_headers.${data[index]}`
      );
    });
  }
  isOwner: boolean = false
  ngOnInit(): void {
    // this.updateColumnHeaders()
    this.isOwner = this.authService.isOwner() 
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      // this.entityHashIdForSearch = data.entityHash
    });

    this._apiService.getEntityInventoryInOutData(
      this.entityHashId,
      this.page.toString()
    );
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
  openInventoryItems() {
    this.router.navigate(["inventory-items"], {
      queryParamsHandling: "preserve",
      relativeTo: this.activatedRoute,
    });
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getEntityInventoryInOutData(
      this.entityHashId,
      this.page.toString()
    );
  }

  // onRecordUsageAndFinish(){
  //   // this.loaderservice.showLoader = true;
  //   this._modelRef.open(InventoryItemsForMiscComponent, {
  //         width: '1000px',
  //         minWidth: "400px",
  //         data: {
  //           title: 'Record usage/finish',
  //           ref: this._modelRef,
  //         },
  //       });
  //     }
  onRevertUsage(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message:
          "This will remove the usage record and increase the stock as well. Are you sure you want to continue?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodyData = {
          entity_hash_id: this.entityHashId,
          itemHashId: rowvalue.item_hash_id,
          activityHashId: rowvalue.hash_id,
        };
        // this.loader = true;
        this.loaderservice.showLoader = true;
        this._apiService.editInventoryActivity(bodyData);
      }
    });
  }

  onRecordUsage() {
    this._modelRef.open(InventoryItemsForMiscComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Inventory items",
        operation_type: 2,
        ref: this._modelRef,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }
  OnIncreaseStock() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Stock update will only increase your initial item quantity counts. It's not going to add any purchase/price related data. If you have purchased the item(s), add the record from the Purchase section.",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        this._modelRef.open(InventoryItemsForMiscComponent, {
          // width: '1000px',
          // minWidth: "400px",
          data: {
            title: "Inventory items",
            operation_type: 1,
            ref: this._modelRef,
            toShowTemplate: true,
          },
          disableClose: true,
        });
      }
    });
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }

  checkDisablity(item:any){
    if(this.isOwner){
      if(item.operation_type == 1){
        return true

      }
      else{
        return false
      }
    }
    else{
      if(item.created_by_hash == localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)){
        if(item.operation_type == 1){
          return true
  
        }
        else{
          return false
        }
      }
      else{
        return true
      }
    }
  }
}
